// extracted by mini-css-extract-plugin
export var logo = "Header-module--logo--aVWNJ";
export var navigation = "Header-module--navigation--KRS1X";
export var red = "Header-module--red--IsQTr";